import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider } from "@/lib/adminAuth";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import About from "@/components/sections/About";
import PrimoGroup from "@/components/sections/PrimoGroup";
import InstagramFeed from "@/components/sections/InstagramFeed";
import Services from "@/components/sections/Services";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Landing = () => (
  <div data-testid="landing-page" className="bg-ivory text-charcoal min-h-screen">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <About />
      <PrimoGroup />
      <InstagramFeed />
      <Services />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#FAF9F6",
            border: "1px solid #C59B4A",
            borderRadius: 0,
            fontFamily: "'Outfit', sans-serif",
            letterSpacing: "0.08em",
            fontSize: "13px",
          },
        }}
      />
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
